export default [
    "#8884d8",
    "#82ca9d",
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#AF19FF",
]